export enum SeverityTypeEnum {
  Critical = 5,
  Error = 4,
  Warning = 3,
  Info = 2,
  Success = 1,
  Debug = 0,
}